
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/b2b",
      function () {
        return require("private-next-pages/severalbrands/b2b/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/b2b"])
      });
    }
  